<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p style="margin:0pt 0pt 10pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:仿宋_GB2312; font-size:22pt; font-weight:bold">敏感个人信息</span>
            <span style="font-family:仿宋_GB2312; font-size:22pt; font-weight:bold">处理</span>
            <span style="font-family:仿宋_GB2312; font-size:22pt; font-weight:bold">授权书</span>
          </p>
          <p style="margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:仿宋_GB2312; font-size:15pt">&#xa0;</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">特别提示：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别关注字体加黑、加粗表述），关注您对本行的授权内容以及您的权利、义务和责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如您对亿联银行信贷业务个人信息处理活动有任何疑问、意见或建议，您可致电</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">客户服务电话</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行咨询，或者通过贷款人和/或贷款人线上服务平台、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">线上客服</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">等进行咨询了解，查询、获知您行使个人信息主体相关权利的方式和程序。一旦您通过点击或其他方式确认本授权书，即意味着您已知晓、理解本授权书中的全部内容（包括对有关权利义务和/或责任限制、免除条款的法律含义有充分的理解），同意按照本授权书条款处理您的相关信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书是由您出具的授权吉林亿联银行股份有限公司（以下简称“亿联银行”、“被授权人”）处理敏感个人信息的文件。基于您个人同意由亿联银行处理您的个人信息的，您有权撤回同意，但您需了解，在您撤回前已进行的信息收集、处理行为的效力不受影响；若撤回授权，将影响亿联银行为您提供贷款相关服务。您可通过拨打</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">亿联银行客户服务电话95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">咨询贷款相关授权并确认是否撤回同意。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">深知</span>
            <span style="font-family:宋体; font-size:11pt">敏感</span>
            <span style="font-family:宋体; font-size:11pt">个人信息对您的重要性，会尽力维护您的</span>
            <span style="font-family:宋体; font-size:11pt">敏感</span>
            <span style="font-family:宋体; font-size:11pt">个人信息安全，遵循合法、正当、必要、诚信原则开展个人信息处理活动，依法公开处理信息的规则，明示处理信息的目的、方式和范围，并按照法律法规、监管要求及与您的相关约定处理您的个人信息，依法采取相应措施保护您的合法权益。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">请您理解，由于各种因素可能出现亿联银行无法合理预见、防范、避免、控制的意外情形，可能影响到您的个人信息安全，如发生个人信息安全事件，亿联银行将按照法律法规的要求，制定并组织实施个人信息安全事件应急预案，及时采取应急措施予以化解，同时将事件情况以合理有效的方式向您告知。亿联银行还将根据监管机构要求，上报个人信息安全事件及处置情况。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">吉林亿联银行股份有限公司：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:30pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人知悉敏感信息对个人权益的影响，并作为向亿联银行申请贷款服务的借款人，本人同意并授权如下：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">一、本人同意并授权亿联银行处理（包括但不限于收集、存储、使用、加工、传输、提供、公开、删除等）如下敏感个人信息：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">1、个人身份信息：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括证件种类及号码、有效期限、婚姻状况</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">居住地址信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">2、个人财产信息：银行账户信息、资产信息、房产信息、收入状况、信贷记录、征信信息、交易和消费记录、流水记录、税务信息、社保账户信息及公积金信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">3、个人生物识别信息：指纹、声纹、掌纹、虹膜、面部识别特征。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">4、个人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">联系方式</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">联系地址、联系电话、电子邮箱地址</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5、个人其他信息：精准定位信息、设备识别码信息、设备地址信息、常用设备信息、浏览器环境信息、音视频双录信息（包含电核录音、视频连线、视频核验等）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">二</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行基于提供贷款服务的需求，将敏感个人信息用于</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">贷款服务相关的身份识别、资质审查、风险评估、风险管理、贷前调查、审查审批、合同签署、放款审核、额度管理、风险监测、担保办理、客户服务、权益服务、贷后管理（含催收、逾期资产处置、诉讼仲裁）、贷后服务、资产转让、债权转让、客户服务（含投诉处理）、数据研究分析等用途，以及在被授权人监管机构要求的信用监控、授权人申请征信异议处理、依法或依有权部门要求的其他工作，或其他经本人同意的合法用途。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">1、本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的收集、存储、使用、加工</span>
            <span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">在使用</span>
            <span style="font-family:宋体; font-size:11pt">信贷服务</span>
            <span style="font-family:宋体; font-size:11pt">过程中主动提供或因此产生的必要敏感个人信息</span>
            <span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">2、本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的向金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司、行政机关、司法机关、社会保障管理机构、住房公积金管理机构、通信运营商、银行卡清算机构、合法存有</span>
            <span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">信息的第三方以及</span>
            <span style="font-family:宋体; font-size:11pt">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">行内系统，收集、存储必要敏感个人信息，并对其进行必要的使用、加工。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">3、本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：亿联银行</span>
            <span style="font-family:宋体; font-size:11pt">基于风险管理目的，在</span>
            <span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">通过电脑、手机等电子设备使用</span>
            <span style="font-family:宋体; font-size:11pt">贷款</span>
            <span style="font-family:宋体; font-size:11pt">服务时，收集、存储该设备位置信息，并对其进行必要的使用、加工。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">4、本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">出现违约或可能危及</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">债权的情形时，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">无法通过</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">预留联系方式取得有效联系的，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">有权向金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司、行政机关、司法机关、通信运营商、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">的单位和联系人及合法存有</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">信息的第三方收集、存储其他有效联系方式，并对其进行必要的使用、加工</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">。</span>
            <span style="font-weight:bold; font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">本人承诺：向亿联银行提供的第三方联系人信息，本人已充分告知第三方并取得其同意。因本人承诺不实或者第三方因本人提供其信息而向亿联银行索赔，给亿联银行造成损失或其他不利后果的，由本人承担赔偿责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">三、本人同意并授权如亿联银行将本授权书涉及的业务所对应的债权及担保权利转让给第三方时，为订立、履行本人作为一方当事人的合同所必需，亿联银行有权依法合规在必要范围内向潜在受让的金融机构提供本授权书涉及的业务的相关资料及本人信息，而无须另行征得本人同意。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">四、本人知悉并同意在后续的信贷业务相关服务（如额度调整、还款方式变更、客户资料变更等）办理流程中补充及调整相关个人信息，如个人身份信息、联系方式、学历学籍信息、居住信息、职业信息、账户信息、交易信息等必要信息时，无需重新进行授权。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">五、本人同意并自愿授权：亿联银行将收集的个人信息进行存储，保存期限为本授权书生效之日起至本人与亿联银行业务关系终结之日另加【5】年。如法律、行政法规、政府规章、监管规范（包括但不限于反洗钱）对客户个人信息资料有更长保存期限要求的，遵守其规定。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">六、风险提示：敏感个人信息等信息为重要且</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">私密的个人信息，一旦泄露或者非法使用，容易导致人格尊严受到侵害或者人身、财产安全受到危害。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">七、本人授权并同意，本授权书所称敏感个人信息的处理，本授权书未约定的，按照本人与亿联银行签订的《个人信息处理授权书》约定处理。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">八、若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">九、本授权书系本人对亿联银行的单方承诺，效力具有独立性，不因其他合同的任何条款无效而失效。本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务终结之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人声明：本人已年满【</span>
            <span style="font-family:宋体; font-size:11pt">系统填充</span>
            <span style="font-family:宋体; font-size:11pt">】周岁。本人同意本授权书以数据电文形式成立，自本人在线确认起即生效。本人已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt">授权人：【</span>
            <span style="font-family:宋体; font-size:11pt">系统填充</span>
            <span style="font-family:宋体; font-size:11pt">】</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt">身份证件号码：【 </span>
            <span style="font-family:宋体; font-size:11pt">系统填充 </span>
            <span style="font-family:宋体; font-size:11pt">】</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-align:justify; widows:0">
            <span style="font-family:宋体; font-size:11pt">签署日期（授权书生效日期）：【</span>
            <span style="font-family:宋体; font-size:11pt">系统填充</span>
            <span style="font-family:宋体; font-size:11pt">】</span>
          </p>
        </div>
    </div>
  </div>
  </div>
</template>
<script>

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
